import axios from "axios";
import _groupBy from "lodash/groupBy";
import _sortBy from "lodash/sortBy";

import ENV from "config/Env";
import { typedQueryClient } from "hooks";
import { ACL } from "models";
import { User } from "models";
import { AuthKeys } from "modules/Auth/queryKeys";
import apiInstance from "util/Api";

export interface UserAcls extends User {
  roleACLs: Record<string, ACL[]> | null;
}

class AuthService {
  static async getUser() {
    const token = apiInstance.authToken;
    try {
      const res = await axios.post(`${ENV.authBaseUrl}/session/me`, {}, { headers: { Authorization: `Bearer ${token}`, Pragma: "no-cache" } });
      const userResponse: User = res.data.data;

      const loadedUser: UserAcls = { ...userResponse, roleACLs: userResponse.acl ? _groupBy(_sortBy(userResponse.acl, "resource"), "resource") : {} };
      return loadedUser;
    } catch (e) {
      console.warn("userInfo error", e);
      return null;
    }
  }

  static async loadUser() {
    try {
      const user = await AuthService.getUser();
      if (user) {
        typedQueryClient.setQueryData(AuthKeys.user, user);
        return user;
      }
      return null;
    } catch (e) {
      console.warn("userInfo error", e);
      return null;
    }
  }
}

export default AuthService;
